import React from "react";
import "./ConfigPane.scss";
import "../JSONHTML.css";
import { toast } from "react-toastify";

import ConfigPaneFormRow from "./ConfigPaneFormRow";
import { JSON2HTML, pathArray2Val } from "../../../../helpers/JSONParser";
import {
  devicePropNames2Labels,
  templateIsQuerx,
  ISDEV
} from "../../../../helpers/constants";
import PalamButton from "../../../generic/palam_button";

import { withTranslation } from 'react-i18next';


class DeviceConfigPane extends React.Component {
  constructor(props) {
    super(props);
    this.state = { JSONPreviewIdx: 0, focusedInput: -1 };
  }

  componentDidMount() {
    console.log("DeviceDataConfigPane did Mount!");
    let pre = document.getElementById("jsonpre");
    pre.addEventListener("click", this.onJSONPropClick.bind(this));
  }

  componentWillUnmount() {
    console.log("DeviceDataConfigPane did Unmount!");
  }

  onJSONPropClick(evt) {
    let { device, requestSetDeviceDataValue } = this.props;

    if (!evt.target.classList || evt.target.classList[0] !== "jsh-val") {
      return;
    }
    console.log(
      "clicked JSON prop",
      evt.target.innerText,
      "path:",
      evt.target.dataset.path
    );
    //console.log("666", Object.keys(device.dataConfig), this.state.focusedInput);
    let currentKey = Object.keys(device.dataConfig)[this.state.focusedInput];
    if (!currentKey) {
      toast.error("Select a property first!");
      return;
    }
    requestSetDeviceDataValue(
      device.uid,
      currentKey,
      evt.target.dataset.path,
      "JSON"
    );
  }

  onStepJSONPreview(incr) {
    let JSONLength = this.props.device.rawJSONS.length;
    let currentIdx = this.state.JSONPreviewIdx;
    let newIdx;
    console.log("777", currentIdx, JSONLength);
    if (currentIdx >= JSONLength - 1 && incr) {
      newIdx = 0;
    } else if (currentIdx === 0 && !incr) {
      newIdx = JSONLength - 1;
    } else {
      newIdx = incr ? currentIdx + 1 : currentIdx - 1;
    }
    this.setState({ JSONPreviewIdx: newIdx });
  }

  onInputFocus(idx) {
    console.log("oninputfocus", idx);
    this.setState({ focusedInput: idx });
  }

  onManualEdit(evt) {
    let { device, setDeviceDataValue } = this.props;
    let currentKey = Object.keys(device.dataConfig)[this.state.focusedInput];
    console.log("manual edit", evt.target.value);
    setDeviceDataValue(device.uid, currentKey, evt.target.value, "manual");
  }

  onBlur(evt) {
    let { device, requestSetDeviceDataValue } = this.props;
    let currentKey = Object.keys(device.dataConfig)[this.state.focusedInput];
    if (evt.target.value !== "") {
      requestSetDeviceDataValue(
        device.uid,
        currentKey,
        evt.target.value,
        "manual"
      );
    }
    this.onInputFocus(-1);
  }

  onClear() {
    let { device, requestSetDeviceDataValue } = this.props;
    let currentKey = Object.keys(device.dataConfig)[this.state.focusedInput];
    if (!currentKey) {
      return;
    }

    requestSetDeviceDataValue(device.uid, currentKey, "", undefined);
  }

  onResetJSONState() {
    let { device } = this.props;
    this.props.requestResetJSONState(device.uid);
  }

  renderFormRows(dataConfig, rawJSON) {
    let {t} = this.props;
    let labels = Object.keys(dataConfig);

    let els = labels.map((label, idx) => {
      let isColor = label === "color";

      label = devicePropNames2Labels[label];
      // If the method is JSON, send the extracted value from the currently selected JSON, instead of the path
      let value = dataConfig[Object.keys(dataConfig)[idx]].value;
      let method = dataConfig[Object.keys(dataConfig)[idx]].method;
      if (method === "JSON") {
        let path = value;
        // Path is an array of keys/idxs
        //value = rawJSON[JSON.parse(path)];
        value = pathArray2Val(path, rawJSON, t("json_noval"));
      }

      return (
        <ConfigPaneFormRow
          label={t(label)}
          value={value}
          method={method}
          isColor={isColor}
          key={idx}
          isFocused={this.state.focusedInput === idx}
          onFocus={() => {
            this.onInputFocus(idx);
          }}
          onBlur={this.onBlur.bind(this)}
          onManualEdit={this.onManualEdit.bind(this)}
          onClear={this.onClear.bind(this)}
        />
      );
    });
    return els;
  }

  render() {
    let {
      device,
      requestActivateTemplate,
      //setDetectedQuerx,
      resetDetectedQuerx,
      t
    } = this.props;
    let { rawJSON } = device;
    let json = JSON.stringify(rawJSON) || "{}";

    let json_template_id = (rawJSON && rawJSON["template"]) || undefined;

    let device_template_id = device.template_id || false; // template id saved for this device
    let device_qname = templateIsQuerx(device_template_id);
    let json_qname = templateIsQuerx(json_template_id);
    // TODO: differentiate between a sent template_id and if the template is actually active.

    let html = JSON2HTML(json);
    return (
      <div className="configpane-inner">
        {device_template_id && (
          <div className="infopanel success">
            {t("autoconfig_success_label",{device_qname})}
          </div>
        )}
        {!device_template_id && json_qname && (
          <div className="infopanel">
            <p>
              {t("autoconfig_success_label",{json_qname})}
            </p>
            <br />
            <PalamButton
              extraClasses="highlight inline-block"
              onClick={e => {
                requestActivateTemplate(device.uid, json_template_id);
                resetDetectedQuerx();
              }}
            >
          <div className="palam-button-label">{t("yes_word")}</div>
            </PalamButton>
          </div>
        )}

        {false && ISDEV && (
          <div className="configpane-form">
            {/* This currently only sets the template_id field to false on server and in redux.
              Later this is the right place to actually reset the whole device to default. */}
            {
              <div className="devbox">
                <span>Current Template ID: {device.template_id}</span>
                <br />
                <button
                  onClick={e => {
                    if (
                      window.confirm(
                        "Are you sure you wish to reset the template?"
                      )
                    ) {
                      this.props.requestResetTemplateId(device.uid);
                    }
                    //this.deleteItem(e);
                  }}
                >
                  requestResetTemplateId
                </button>
                <br />
                <button
                  onClick={e => {
                    if (
                      window.confirm(
                        "Are you sure you wish to reset the device? This will also delete all it's sensors, along with all historical sensor data associated with those sensors."
                      )
                    ) {
                      this.props.requestResetDevice(device.uid);
                      this.props.removeFromDeviceTemplateBlacklist();
                    }
                    //this.deleteItem(e);
                  }}
                >
                  requestResetDevice
                </button>
                <br />
                <br />

                <button
                  onClick={e => {
                    if (
                      window.confirm(
                        "Are you sure you wish to save the template?"
                      )
                    ) {
                      this.props.requestSaveTemplate(device.uid);
                    }
                    //this.deleteItem(e);
                  }}
                >
                  requestSaveTemplate
                </button>
              </div>
            }
          </div>
        )}

<br/>
        <div className="configpane-container">
          <div className="configpane-form">
            {/* One dummy row as legend */}
            <ConfigPaneFormRow isLegend />
            {this.renderFormRows.bind(this)(device.dataConfig, rawJSON)}
          </div>

          <div className="configpane-code">
            <pre id="jsonpre" dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>

        <div className="configpane-form">
          <div className="centered flex between">
            <div className="centered flex start">
              <PalamButton
                extraClasses="warning"
                onClick={e => {
                  if (
                    window.confirm(
                      t("delete_device_prompt")
                    )
                  ) {
                    this.props.requestDeleteDevice(device.uid);
                  }
                  //this.deleteItem(e);
                }}
              >
                <div className="palam-button-label">{t("delete_device_label")}</div>
              </PalamButton>
              &nbsp;
              <PalamButton
                extraClasses="warning"
                onClick={e => {
                  if (
                    window.confirm(
                      t("reset_config_prompt")
                    )
                  ) {
                    this.props.requestResetDevice(device.uid);
                    this.props.removeFromDeviceTemplateBlacklist(device.uid);
                  }
                  //this.deleteItem(e);
                }}
              >
                <div className="palam-button-label">{t("reset_config_label")}</div>
              </PalamButton>
            </div>
            <PalamButton onClick={this.onResetJSONState.bind(this)}>
              {t("reset_json_label")}
            </PalamButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DeviceConfigPane);
